import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {User} from "../../models";
import {UserService} from "../../services";

@Injectable()
export class CustomerResolve implements Resolve<User> {
    constructor(private userService: UserService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<User> {
        return this.userService.getById(route.params.id??route.params.customerId);
    }
}
